import type { ReactNode } from 'react';

type PillTone = 'success' | 'warning' | 'muted' | 'brand';

const PILL_TONES: Record<PillTone, { wrap: string; dot: string }> = {
  success: { wrap: 'bg-success-tint text-success', dot: 'bg-success' },
  warning: { wrap: 'bg-warning-tint text-warning', dot: 'bg-warning' },
  brand: { wrap: 'bg-brand-tint text-brand', dot: 'bg-brand' },
  muted: { wrap: 'bg-surface-3 text-fg-secondary', dot: 'bg-fg-muted' },
};

interface StatusPillProps {
  tone?: PillTone;
  /** Show a leading status dot. */
  dot?: boolean;
  children: ReactNode;
}

export function StatusPill({ tone = 'muted', dot = true, children }: StatusPillProps) {
  const t = PILL_TONES[tone];
  return (
    <span
      className={`inline-flex shrink-0 items-center gap-1.25 rounded-xs px-2 py-0.75 text-2xs font-medium leading-3.5 ${t.wrap}`}
    >
      {dot && <span className={`size-1.5 rounded-full ${t.dot}`} />}
      {children}
    </span>
  );
}
